import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "pricing",
  class: "pricing-wrap pt-100 pb-75"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "pricing-table style8" }
const _hoisted_5 = { class: "pricing-header" }
const _hoisted_6 = { class: "pricing-header-tag" }
const _hoisted_7 = { class: "pricing-features" }
const _hoisted_8 = { class: "list-style" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row" }, [
        _createElementVNode("div", { class: "col-xl-6 offset-xl-3 col-lg-8 offset-lg-2" }, [
          _createElementVNode("div", { class: "section-title style3 text-center mb-40" }, [
            _createElementVNode("span", null, "Our Pricing Plan"),
            _createElementVNode("h2", null, [
              _createTextVNode(" Our High Quality "),
              _createElementVNode("span", null, " Easy Price"),
              _createTextVNode(" Without Any Hidden Fees ")
            ])
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pricings, (pricing) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-4 col-lg-6 col-md-6",
            key: pricing.id
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", null, _toDisplayString(pricing.title), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h3", null, [
                    _createTextVNode(" $" + _toDisplayString(pricing.price) + " ", 1),
                    _createElementVNode("span", null, "/Per " + _toDisplayString(pricing.period), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[0] || (_cache[0] = _createElementVNode("h5", null, "Our Best Features:", -1)),
                _createElementVNode("ul", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pricing.features, (feature) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: feature.id,
                      class: _normalizeClass(feature.class)
                    }, _toDisplayString(feature.text), 3))
                  }), 128))
                ])
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "purchase-pricing" }, [
                _createElementVNode("a", {
                  href: "#",
                  class: "btn style1"
                }, "Choose This Plan")
              ], -1))
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}